<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;" @click="$router.go(-1)">客户列表</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客户详情</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>


        <!-- 上半部分 -->
        <div class="detailContent">
            <div class="upperInfoContent">
                <div class="title">
                    <span class="name"><span v-if="cluedetail.username">{{cluedetail.username}}</span>
                    <span class="name" v-else>--</span></span>
                    <!-- <a-tag color="orange">{{cluedetail.clue_type}}</a-tag> -->
                </div>
                 <div class="back-btn">
                    <a-button style="margin-right:12px" @click="back" type="primary">返回</a-button>
                    <a-button-group>
                        <a-button @click="prev" icon="left" />
                        <a-button @click="next" icon="right" />
                    </a-button-group>
                </div>

                <div class="fieldContainer">
                    <div class="fieldItem">
                        <span>手机：</span>
                        <span v-if="cluedetail.telephone">
                            <a v-if="pwdtype==1" href="javascript:;">{{cluedetail.telephone}}</a>
                            <a v-if="pwdtype==2" href="javascript:;">{{cluedetail.telephone | topwd}}</a>
                            <a v-if="pwdtype==3" href="javascript:;">{{cluedetail.telephone | tomd5}}</a>
                        </span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>地址：</span>
                        <span v-if="cluedetail.address">{{cluedetail.address}}</span>
                        <span v-else>--</span>   
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>最近跟进时间：</span>
                        <span v-if="cluedetail.updatetime">{{cluedetail.updatetime | formatDate}}</span>
                        <span v-else>--</span>
                    </div>
                </div>

                <div class="btnListContainer" >
                    <a-button @click="tokehu" type="primary"><a-icon type="snippets" theme="filled"/>跟进线索</a-button>
                    
                    <!-- <a-button @click="tokehu" type="primary"><a-icon type="snippets" theme="filled"/>跟进线索</a-button> -->
                    <a-button @click="totel(usid)"><a-icon type="phone" theme="filled"/>拨打电话</a-button>
                </div>
            </div>
        </div>

        <!-- 下半部分 -->
        <div class="lowerInfoContent">
            <div class="basicinfo">
                
                <div class="information">
                    <div class="informationLeft">
                        <div class="title">
                            <img src="../../../static/flag.png" alt="">
                            <span>基本信息</span>
                        </div>
                        <a-descriptions bordered :column="2" :size="size">
                             <a-descriptions-item label="姓名">
                            {{cluedetail.username}}
                            </a-descriptions-item>
                           
                            <a-descriptions-item label="性别">
                            <span v-if="cluedetail.sex==1">男</span>
                            <span v-if="cluedetail.sex==2">女</span>
                            <span v-else>--</span>
                            <!-- <span v-if="cluedetail.sex==1">男</span>
                            <span v-else>女</span> -->
                            </a-descriptions-item>
                             <a-descriptions-item label="电话">
                            <span v-if="pwdtype==1">{{cluedetail.telephone}}</span>
                            <span v-if="pwdtype==2">{{cluedetail.telephone | topwd}}</span>
                            <span v-if="pwdtype==3">{{cluedetail.telephone | tomd5}}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="线索来源">
                            {{cluedetail.title_sources}}
                            </a-descriptions-item>
                            <!-- <a-descriptions-item label="付款状态">
                                <a-tag v-if="cluedetail.state_pay==0" color="orange">未支付</a-tag>
                                <a-tag v-if="cluedetail.state_pay==1" color="green">已支付</a-tag>
                                <a-tag v-if="cluedetail.state_pay==3" color="blue">已退款</a-tag>
                            </a-descriptions-item>
                             <a-descriptions-item label="物流状态">
                                <a-tag v-if="cluedetail.state_wl=='未发货'" color="orange">{{cluedetail.state_wl}}</a-tag>
                                <a-tag v-if="cluedetail.state_wl=='已签收'" color="blue">{{cluedetail.state_wl}}</a-tag>
                                <a-tag v-if="cluedetail.state_wl=='已激活'" color="green">{{cluedetail.state_wl}}</a-tag>
                            </a-descriptions-item>
                            <a-descriptions-item label="激活状态">
                                <a-tag v-if="cluedetail.state_jh=='未激活'" color="orange">{{cluedetail.state_jh}}</a-tag>
                                <a-tag v-if="cluedetail.state_jh=='已激活'" color="green">{{cluedetail.state_jh}}</a-tag>
                            </a-descriptions-item> -->
                            <a-descriptions-item label="跟进时间">
                            {{cluedetail.updatetime | formatDate}}
                            </a-descriptions-item>
                            <!-- <a-descriptions-item label="状态">
                            未激活
                            </a-descriptions-item> -->
                        
                            <a-descriptions-item label="地址" :span="3">
                            {{cluedetail.province}}{{cluedetail.city}}{{cluedetail.area}}{{cluedetail.address}}
                            </a-descriptions-item>
                            <a-descriptions-item label="备注" :span="3">
                            {{cluedetail.remarks}}
                            </a-descriptions-item>
                        </a-descriptions>
                    </div>
                    <div class="informationRight">
                        <div class="title" style="margin-bottom:6px">
                            <img src="../../../static/flag.png" alt="">
                            <span>客户动态</span>
                        </div>

                        <a-tabs default-active-key="1" >
                            <a-tab-pane key="1" tab="跟进动态">
                                <a-timeline v-if="recordlist.length>0" style="padding-top:10px">
                                    <div v-for="(item,i) in recordlist" :key="i">
                                        <a-timeline-item >
                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                            <div class="date-arrow">{{item.addtime | formatDate}}</div>
                                        </a-timeline-item>
                                        <a-timeline-item>
                                            <div class="description">
                                                <div class="dataContainer">
                                                    <div v-if="item.fileurl" style="padding-top:20px">
                                                        <audio class="detail-audio" controls="controls"  :src="item.fileurl"></audio> 
                                                    </div>
                                                    <span class="follow-title" v-if="item.title_isvalid">{{item.title_isvalid}}</span>
                                                    <span class="follow-date" v-if="item.callOutStartTime"><a-icon type="clock-circle"/>{{item.callOutStartTime}}</span>
                                                    <span class="follow-date" v-else><a-icon type="clock-circle"/>{{item.addtime | showdate}}</span>
                                                    <div class="gjcontent" v-if="item.remarks_log">{{item.remarks_log}}</div>
                                                    <div class="cz-user"><p>操作人：<span>{{item.username_kf}}</span></p></div>
                                                </div>
                                            </div>

                                        </a-timeline-item>
                                    </div>
                                </a-timeline>

                                <a-empty v-else description="暂无数据"/>
                            </a-tab-pane>
                            <!-- <a-tab-pane key="2" tab="物流动态" force-render>
                                <a-timeline v-if="data_logistics" style="padding-top:10px">
                                    <div v-for="(item,i) in data_logistics" :key="i">
                                        <a-timeline-item >
                                            <span slot="dot" class="steps-index-TimeDot"></span>
                                            <div class="date-arrow">{{item.time}}</div>
                                        </a-timeline-item>
                                        <a-timeline-item>
                                            <div class="description">
                                                <div class="dataContainer">
                                                    <span class="follow-date"><a-icon type="clock-circle"/>{{item.time}}</span>
                                                    <div class="gjcontent">{{item.context}}</div> 
                
                                                </div>
                                            </div>
                                        </a-timeline-item>
                                    </div>
                                </a-timeline>

                                <a-empty v-else description="暂无数据"/>
                            </a-tab-pane> -->
                        </a-tabs>
                        
                    </div>
                </div>
                 
            </div>
        </div>

         <a-modal
        title="线索跟进"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="khhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="线索操作">
                    <a-radio-group name="radioGroup" :default-value="1" @change="ontypeChange">
                        <a-radio :value="1">
                        转客户
                        </a-radio>
                        <a-radio :value="0">
                        状态跟进
                        </a-radio>
                        <a-radio :value="2">
                        无效
                        </a-radio>
                    </a-radio-group>
                </a-form-item>

                <!-- <a-form-item label="购卡数量" v-if="numshow">
                    <a-input-number v-model="num" :precision="0" max="10" min="1" v-decorator="['购卡数量', { rules: [{ required: true, message: '请输入购卡数量' }] }]" />
                </a-form-item> -->

                <a-form-item label="跟进状态" v-if="numshow1">
                    <a-radio-group name="radioGroup"  @change="onstatusChange">
                        <a-radio :value="item.isvalid" v-for="item in statuslist" :key="item.isvalid">
                        {{item.title}}
                        </a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item label="回访时间" v-if="numshow1">
                    <a-date-picker :locale="locale" @change="onhfChange" placeholder="请选择回访时间"/>
                </a-form-item>
                

                
                <a-form-item label="姓名">
                    <a-input v-model="cluedetail.username" placeholder="请输入客户姓名"/>
                </a-form-item>
                <a-form-item label="电话">
                    <a-input v-model="cluedetail.telephone" placeholder="请输入客户电话"/>
                </a-form-item>
                <a-form-item label="地址">
                    <div style="dispaly:flex;justify-content: space-around;">
                        <!-- <a-cascader v-model="cluedetail.dz"  :field-names="{ label: 'name', value: 'name', children: 'area' }" @change="onaddressChange" :options="adddata" placeholder="请选择省、市、区"  /> -->
                        <v-distpicker :province="cluedetail.province" :city="cluedetail.city" :area="cluedetail.area" @selected="onaddressChange"></v-distpicker>
                    </div>
                   
                    <a-input v-model="cluedetail.address" placeholder="请输入详细地址"/>
                </a-form-item>
                <a-form-item label="性别">
                    <a-radio-group name="radioGroup" @change="cluedetail.sexSelectChange">
                        <a-radio :value="1">
                        男
                        </a-radio>
                        <a-radio :value="2">
                        女
                        </a-radio>
                    </a-radio-group>

                </a-form-item>

                <!-- <a-form-item label="出生日期">
                    <a-date-picker :locale="locale" @change="ondateChange" placeholder="请选择出生日期"/>
                </a-form-item> -->
                <a-form-item label="备注">
                    <a-textarea v-model="cluedetail.remarks" placeholder="备注" :rows="4" />
                </a-form-item>
            </a-form>
        </a-modal>

    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import md5 from 'js-md5'
export default {
    filters: {
      //年-月-日
        formatDate (time) {
            time = time * 1000
            let date = new Date(time)
            return formatDate (date, 'yyyy-MM-dd')
        },
        showdate (time) {
            time = time * 1000
            let date = new Date(time)
            return formatDate (date, 'yyyy-MM-dd hh:mm:ss')
        },

        topwd (value) {
            const start = value.slice(0, 3)
            const end = value.slice(-4)
            return `${start}****${end}`
        },
        tomd5(value){
            const text=md5(value)
            const text2=text.slice(0,10);
            return text2
        }
    },
    data(){
        return{
            cluedetail:"",
            data_logistics:"",
            editvisible:false,
            numshow:true,
            form: this.$form.createForm(this, { name: 'coordinated' }),
            gjrecord:[{date:'2021-06-07',add_time:'2021-06-07',user_name:'admin',content:'跟进内容'}],
            size:'middle',

            usid:"",
            kid:"",
            recordlist:"",
            upnext:"",

            pwdtype:"",

            numshow:true,
            numshow1:false,
            cluedetail:"",
            usxsid:"",
            aid:""
        }
    },
    mounted(){
        this.usid=this.$route.query.id
        this.kid=this.$route.query.kid
        this.getdetail()
        this.getrecord()
        this.pwdtype=localStorage.getItem('pwdtype')
    },
    methods:{
             // 回访时间
        onhfChange(date, dateString) {
            // console.log(date, dateString);
            this.revisitdays=moment(dateString).unix()
        },
          // 客户跟进
        // 状态跟进
        onstatusChange(e){
            this.statusid=e.target.value
        },
         ontypeChange(e) {
            this.isvalid=e.target.value
            if( e.target.value==1||e.target.value==2){
                this.numshow=true
                this.numshow1=false
            }else if( e.target.value==0){
                this.numshow=false
                this.numshow1=true
            }
        },
        // 省市区选择
        onaddressChange(value){
            this.province=value[0]
            this.city=value[1]
            this.area=value[2]
        },
        tokehu(id,aid){
            this.editvisible=true
            this.usxsid=id
            this.getdetail()
            this.aid=aid
        },
        handleCancel(){
            this.editvisible=false
            this.moreTel()
        },
        khhandleOk(){
            this.$axios.post('/api/user/edituser',{
                usid:this.usxsid, 
                province:this.cluedetail.province,
                city:this.cluedetail.city,
                area:this.cluedetail.area,
                isvalid:this.statusid,
                username:this.cluedetail.username,
                telephone:this.cluedetail.telephone,
                address:this.cluedetail.address,
                sex:this.cluedetail.sex,
                birthday:this.birthday,
                remarks:this.cluedetail.remarks,
                isuser:this.isvalid,
                revisitdays:this.revisitdays
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=false
                    this.revisitdays=""
                    this.fetch()
                    this.moreTel()
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },



        // 上一条，下一条
        prev(){
           this.upnext=1
           this.getnextprev()
        },
        next(){
            this.upnext=2
            this.getnextprev()
        },

        getnextprev(){
             this.$axios.post('/api/user/userupnextpage',{
                aid:localStorage.getItem('aid'),
                usid:this.usid,
                upnext:this.upnext
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.cluedetail=res.data.data
                    this.data_logistics=eval('(' + res.data.data.data_logistics + ')')
                    this.usid=res.data.data.usid
                    console.log(this.data_logistics)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        back(){
            this.$router.go(-1);//返回上一层
        },
        totel(id,phone){
     
            if(localStorage.getItem('call_type')==0){
                 var phone=this.cluedetail.telephone
                sendMsg("changesim")

                this.$axios.post('/api/telephoneblack/verifytelephoneblack',{
                    telephone:phone
                },{
                    headers: {
                        "token":localStorage.getItem('token'),
                    }  
                }).then((res)=>{
                    if(res.data.code==200){
                        zhihu(phone)
                    }else{
                        this.$message.error(res.data.msg);
                    }
                })

                // zhihu(phone)
            }else if(localStorage.getItem('call_type')==1){
                       // console.log(id)
                this.$axios.get('https://fxbkfluyin.13524.net/call_do.php?usxsid='+id,{},{
                    headers: {
                        "token":localStorage.getItem('token'),
                    },
                }).then((res)=>{
                    if(res.data.code==100){
                        this.$message.success(res.data.msg); 
                    }else{
                        this.$message.warning(res.data.msg); 
                    }
                })
            }
           
            this.tokehu()
        },
         // 跟进记录
        getrecord(){
            this.$axios.post('/api/user/userloglist1',{
                pagesize: 30,
                usid:this.kid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var data=res.data.data
                    this.recordlist=data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        // 拨打电话
        call(id){

        },

        // 详情

        getdetail(){
            this.$axios.post('/api/user/userpage',{
                usid:this.kid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.cluedetail=res.data.data
                    this.data_logistics=eval('(' + res.data.data.data_logistics + ')')
                    // console.log(this.data_logistics)
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/resources/customdetail.vue